export const inspectTable = [
  {
    content: "물질안전보건자료의 작성 및 제출 (법 제110조)",
    isChecked: "",
  },
  {
    content: "물질안전보건자료의 제공 (법 제111조)",
    isChecked: "",
  },
  {
    content: "물질안전보건자료의 일부 비공개 승인 (법 제112조)",
    isChecked: "",
  },
  {
    content: "근로자에 대한 물질안전보건자료에 관한 교육 (법 제114조)",
    isChecked: "",
  },
  {
    content: "화학물질 양도·제공·사용 시 용기 및 포장에 대한 경고표시 (법 제115조)",
    isChecked: "",
  },
];
